export const tool = Object.freeze({
  appointment: 'tool-appointment',
  interestCompare: 'tool-interest-compare',
  maxMortgage: 'tool-max-mortgage',
  maxMortgageIntake: 'tool-max-mortgage-intake',
  maxMortgageInline: 'tool-max-mortgage-inline',
  monthlyExpenses: 'tool-monthly-expenses',
  rateAveraging: 'tool-rate-averaging',
  refinance: 'tool-refinance',
});

export const result = Object.freeze({
  increase: 'result-increase',
  maxMortgageEntrepreneur: 'result-max-mortgage-entrepreneur',
  maxMortgage: 'result-max-mortgage',
  maxMortgageIntake: 'result-max-mortgage-intake',
  refinance: 'result-refinance',
});

export const landingPage = Object.freeze({
  maxMortgage: 'landing-max-mortgage',
  refinance: 'landing-refinance',
  increase: 'landing-increase',
  router: 'landing-router',
});
